import { all, put, takeLatest } from 'redux-saga/effects';
import * as actions from '@dragonfruit/redux/purchase/checkoutOffline';

import { paymentReceiptForOffline } from '@dragonfruit/redux/navigation';

function* checkoutOfflineFLow(action) {
  const {
    payload: { paymentMethodId, paymentType },
  } = action;
  try {
    yield put(paymentReceiptForOffline({ paymentMethodId, paymentType }));
    yield put(action.checkoutOfflineSuccess());
  } catch (err) {
    yield put(actions.checkoutOfflineFailure(err.message));
  }
}

export default function*() {
  yield all([takeLatest(actions.CHECKOUT_OFFLINE, checkoutOfflineFLow)]);
}



// WEBPACK FOOTER //
// ./app/sagas/purchase/checkoutOffline.js